import "design/productCss/productHeader.css";
import CustomBreadCrumbs from "design/common/customBreadCrumbs";
import { useTranslation } from "react-i18next";
const HeaderBackground = (props: any) => {
  const { route } = props;
  const { t } = useTranslation();
  return (
    <div className={"product-header-container"}>
      <div className={"product-header-image"}>
        <div className={"product-header-image-navi"}>
          <CustomBreadCrumbs routes={route} />
        </div>
      </div>
    </div>
  );
};
export default HeaderBackground;
